import axios from "axios";

export const getDepartment = async (id) => {
  try {
    const { data } = await axios.get(`/api/v1/department?id=${id}`);
    return data;
  } catch (error) {
    throw error;
  }
};

export const getDepartments = async (facultyId) => {
  try {
    const { data } = await axios.get(
      `/api/v1/department/faculty?facultyId=${facultyId}`
    );
    return data;
  } catch (error) {
    throw error;
  }
};

export const addDepartment = async ({
  name,
  facultyId,
  description,
  createdBy,
}) => {
  try {
    const { data } = await axios.post("/api/v1/department", {
      name,
      facultyId,
      description,
      createdBy,
    });
    return data;
  } catch (error) {
    throw error;
  }
};

export const editDepartment = async ({
  id,
  name,
  facultyId,
  description,
  modifiedBy,
}) => {
  try {
    const { data } = await axios.patch("/api/v1/department", {
      id,
      name,
      facultyId,
      description,
      modifiedBy,
    });
    return data;
  } catch (error) {
    throw error;
  }
};

export const deleteDepartment = async (id) => {
  try {
    const { data } = await axios.delete(`/api/v1/department?id=${id}`);
    return data;
  } catch (error) {
    throw error;
  }
};

export const deleteDepartments = async (departments) => {
  try {
    const { data } = await axios.post("/api/v1/department/faculties", departments);
    return data;
  } catch (error) {
    throw error;
  }
};
